import { observer } from 'mobx-react-lite';
import { HStack, IconButton } from '@cad-arc';
import { QueueSearchInput } from '../../queues/components/queue-search-input';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { useGoBackToPreviousFirstResponderPage } from '../../common/hooks/use-go-back-to-previous-first-responder-page';
import { FrPageHeader } from '../../fr-page-layout/fr-page-header';
import { FrUnitsTypeFilterMenu } from '../fr-units-type-filter-menu';
import { FrUnitsSortMenu } from '../fr-units-sort-menu';
import { FrQueueOtherOptionsMenu } from '../../common/components/fr-queues/fr-queue-other-options-menu';

export const FrUnitsListHeader = observer(function FrUnitesListHeader() {
    const goBackToPreviousFirstResponderPage = useGoBackToPreviousFirstResponderPage();
    const { open } = useDrawerControls();

    const onClick = () => {
        goBackToPreviousFirstResponderPage();
        open({
            type: 'fr-units-list',
            props: {},
        });
    };

    return (
        <FrPageHeader
            title="Units"
            customStyles={{
                justifyContent: 'space-between',
            }}
        >
            <HStack justifyContent="space-between">
                <HStack justifyContent="flex-end">
                    <QueueSearchInput searchButtonVariant="outline" />
                    <FrQueueOtherOptionsMenu showDisplayTypeOption={false} />
                    <FrUnitsTypeFilterMenu />
                    <FrUnitsSortMenu />
                    <IconButton
                        data-testid="UNITS_LIST_COLLAPSE_PAGE"
                        aria-label="collapse units page"
                        icon="CollapseWindow"
                        onClick={onClick}
                        variant="outline"
                    />
                </HStack>
            </HStack>
        </FrPageHeader>
    );
});
